<div class="overflow-auto p-5" style="height: 75vh">
  <h1 class="text-chathams-blue font-bold text-xl leading-5 tracking-tight mb-3">
    Adicionar motivo de atendimento à fila
  </h1>
  <form (ngSubmit)="addReasonToQueue()" [formGroup]="formGroup">
    <ng-select
      notFoundText="Nenhum item encontrado"
      [items]="reasonOptions"
      placeholder="Motivos de Atendimento"
      formControlName="reasonSelected"
      bindLabel="description"
      bindValue="id"
      [multiple]="true"
    >
    </ng-select>

    <h2 class="text-chathams-blue font-bold text-base leading-5 tracking-tight mt-6 mb-3">Motivos de exceção</h2>
    <ng-select
      notFoundText="Selecione primeiro os motivos da fila"
      [items]="exceptionReasonOptions"
      placeholder="Motivos de exceção"
      formControlName="exceptionReasonSelected"
      bindLabel="description"
      bindValue="id"
      [multiple]="true"
    >
    </ng-select>

    <div class="flex items-center justify-center m-4">
      <button class="w-80 btn btn--secondary mr-5" type="submit" [disabled]="!motivosCarregados">
        Atualizar Motivo
      </button>
    </div>
  </form>
</div>
